<template>
  <div class="audio-container">
    <audio controls class="audio-controls">
      <source :src="audiourl">
    </audio>
  </div>
</template>


<style lang="scss">
  .audio-container {
    height: 240px;
    width: 240px;
    margin: 40px;
    display: flex;
    align-items: center;
    background: linear-gradient(to bottom, white, DarkGray);
  }

  .audio-controls {
    margin-left: -13px;
    margin-right: auto;
  }

</style>

<script>
export default {
  name: 'single-free-voice',
  props: ['audiourl']
}
</script>



// WEBPACK FOOTER //
// src/components/previews/SingleFreeVoice.vue